export const emojiMetadata = {
   // Smileys Category
  '😀': ['grin', 'happy', 'smile', 'joy', 'grinning', 'cheerful', 'elated'],
  '😃': ['happy', 'joy', 'grin', 'smile', 'big eyes', 'excited', 'elated'],
  '😄': ['laugh', 'happy', 'joy', 'smile', 'grin', 'laughing', 'haha'],
  '😁': ['grin', 'beaming', 'happy', 'smile', 'proud', 'satisfied'],
  '😅': ['sweat', 'smile', 'nervous', 'relief', 'awkward', 'embarrassed'],
  '😂': ['joy', 'tears', 'laugh', 'crying', 'lol', 'haha', 'lmao', 'laughing'],
  '🤣': ['rofl', 'rolling', 'laugh', 'lol', 'haha', 'lmao', 'laughing'],
  '😊': ['blush', 'happy', 'smile', 'sweet', 'shy', 'kind', 'pleasant'],
  '😇': ['angel', 'innocent', 'halo', 'saint', 'pure', 'good'],
  '🙂': ['smile', 'slight', 'happy', 'content', 'fine', 'okay'],
  '🙃': ['upside', 'down', 'silly', 'sarcastic', 'ironic', 'playful'],
  '😉': ['wink', 'flirt', 'joke', 'hint', 'playful', 'suggestive'],
  '😌': ['relieved', 'content', 'calm', 'peaceful', 'relaxed', 'satisfied'],
  '😍': ['love', 'heart', 'eyes', 'crush', 'adore', 'infatuated', 'romantic'],
  '🥰': ['hearts', 'love', 'adore', 'smiling', 'affection', 'loving'],
  '😘': ['kiss', 'love', 'heart', 'flirt', 'affection', 'blowing kiss'],
  '😗': ['kiss', 'neutral', 'peck', 'smooch'],
  '😙': ['kiss', 'smile', 'happy', 'affection', 'sweet'],
  '😚': ['kiss', 'blush', 'shy', 'sweet', 'closed eyes'],
  '😋': ['yum', 'tongue', 'tasty', 'delicious', 'savoring', 'food'],
  '😛': ['tongue', 'playful', 'silly', 'tease', 'goofy', 'joke'],
  '😝': ['tongue', 'squint', 'goofy', 'silly', 'playful', 'wacky'],
  '😜': ['wink', 'tongue', 'silly', 'playful', 'goofy', 'crazy'],
  '🤪': ['crazy', 'silly', 'goofy', 'wild', 'zany', 'wacky'],
  '🤨': ['raised eyebrow', 'suspicious', 'skeptical', 'doubt', 'questioning'],
  '🧐': ['monocle', 'sophisticated', 'examine', 'investigate', 'posh'],
  '🤓': ['nerd', 'geek', 'glasses', 'smart', 'studious', 'brainy'],
  '😎': ['cool', 'sunglasses', 'confident', 'awesome', 'swagger', 'chill'],
  '🤩': ['star struck', 'excited', 'amazed', 'impressed', 'wow', 'awe'],
  '🥳': ['party', 'celebration', 'birthday', 'festive', 'happy', 'hooray'],
  '😏': ['smirk', 'flirt', 'suggestive', 'smug', 'knowing', 'sly'],
  '😒': ['unamused', 'unimpressed', 'annoyed', 'side eye', 'whatever'],
  '😞': ['sad', 'disappointed', 'unhappy', 'down', 'upset'],
  '😔': ['sad', 'pensive', 'thoughtful', 'disappointed', 'down'],
  '😟': ['worried', 'concerned', 'anxious', 'nervous', 'uneasy'],
  '😕': ['confused', 'puzzled', 'unsure', 'uncertain', 'perplexed'],
  '😣': ['persevere', 'struggling', 'tired', 'strained', 'effort'],
  '😖': ['confounded', 'frustrated', 'upset', 'distressed', 'troubled'],
  '😫': ['tired', 'exhausted', 'weary', 'done', 'fed up'],
  '😩': ['weary', 'exhausted', 'dramatic', 'tired', 'distressed'],
  '😢': ['cry', 'sad', 'tear', 'unhappy', 'upset', 'weep'],
  '😭': ['sob', 'cry', 'tears', 'sad', 'bawling', 'weeping'],
  '😤': ['angry', 'mad', 'frustrated', 'steam', 'triumph', 'determined'],
  '😠': ['angry', 'mad', 'upset', 'furious', 'rage'],
  '😡': ['rage', 'angry', 'mad', 'furious', 'red', 'pouting'],
  '🤬': ['cursing', 'swearing', 'angry', 'rage', 'symbols', 'mad'],
  '🤯': ['mind blown', 'explosion', 'shocked', 'amazed', 'boom', 'wow'],
  '😳': ['flushed', 'shocked', 'surprised', 'blushing', 'embarrassed'],
  '🥵': ['hot', 'heat', 'sweating', 'exhausted', 'thirsty', 'summer'],
  '🥶': ['cold', 'freezing', 'ice', 'winter', 'shivering', 'frozen'],
  '😱': ['scream', 'scared', 'shocked', 'fear', 'horror', 'terrified'],
  '😨': ['scared', 'fearful', 'afraid', 'worried', 'shocked'],
  '😰': ['anxious', 'worried', 'nervous', 'sweat', 'stress'],
  '😥': ['sad', 'disappointed', 'relieved', 'sweat', 'phew'],
  '😓': ['sweat', 'stress', 'tired', 'exhausted', 'downcast'],
  '🤗': ['hug', 'embrace', 'hands', 'happy', 'love', 'cuddle'],
  '🤔': ['think', 'thinking', 'thoughtful', 'consider', 'ponder', 'hmm'],
  '🤭': ['oops', 'giggle', 'secret', 'covering mouth', 'surprise'],
  '🤫': ['shh', 'quiet', 'silence', 'secret', 'hushing'],
  '🤥': ['lie', 'liar', 'pinocchio', 'fibbing', 'untruth'],
  '😶': ['blank', 'silent', 'quiet', 'speechless', 'mouthless'],
  '😐': ['neutral', 'straight face', 'meh', 'poker face', 'blank'],
  '😑': ['expressionless', 'unimpressed', 'blank', 'emotionless'],
  '😬': ['grimace', 'awkward', 'nervous', 'yikes', 'cringe'],
  '🙄': ['eye roll', 'whatever', 'sarcastic', 'annoyed', 'ugh'],
  '😯': ['hushed', 'surprised', 'wow', 'shock', 'amazed'],
  '😦': ['frown', 'shocked', 'open mouth', 'surprise', 'concern'],
  '😧': ['anguish', 'shock', 'surprise', 'distress', 'worry'],
  '😮': ['open mouth', 'surprise', 'shock', 'wow', 'gasp'],
  '😲': ['astonished', 'shocked', 'surprise', 'wow', 'amazed'],
  '🥱': ['yawn', 'tired', 'sleepy', 'bored', 'exhausted'],
  '😴': ['sleep', 'tired', 'snooze', 'rest', 'nap', 'zzz'],
  '🤤': ['drool', 'hungry', 'desire', 'food', 'sleepy'],
  '😪': ['sleepy', 'tired', 'snooze', 'drowsy', 'yawn'],
  '😵': ['dizzy', 'confused', 'dead', 'spin', 'spiral'],
  '🤐': ['zipper', 'quiet', 'silence', 'secret', 'shut up'],
  '🥴': ['woozy', 'dizzy', 'drunk', 'tipsy', 'confused'],
  '🤢': ['sick', 'nauseous', 'green', 'ill', 'vomit'],
  '🤮': ['vomit', 'sick', 'throw up', 'ill', 'barf'],
  '🤧': ['sneeze', 'sick', 'tissue', 'cold', 'flu'],
  '😷': ['mask', 'sick', 'ill', 'hospital', 'doctor', 'medical'],
  '🤒': ['thermometer', 'sick', 'ill', 'fever', 'temperature'],
  '🤕': ['bandage', 'hurt', 'injury', 'pain', 'hospital'],

  // Art Category
  '🎨': ['art', 'paint', 'palette', 'artist', 'colors', 'creative', 'drawing'],
  '🖌️': ['brush', 'paint', 'art', 'artist', 'creative', 'drawing'],
  '🖼️': ['frame', 'picture', 'art', 'painting', 'gallery', 'museum'],
  '✏️': ['pencil', 'write', 'draw', 'sketch', 'art', 'school'],
  '📝': ['memo', 'write', 'note', 'paper', 'document', 'writing'],
  '✒️': ['pen', 'write', 'ink', 'black', 'writing', 'signature'],
  '🖋️': ['fountain pen', 'write', 'ink', 'signature', 'elegant'],
  '📏': ['ruler', 'straight', 'measure', 'length', 'school'],
  '📐': ['triangle', 'ruler', 'measure', 'geometry', 'school'],
  '✂️': ['scissors', 'cut', 'tool', 'craft', 'sharp'],
  '🎭': ['theater', 'drama', 'masks', 'acting', 'performance', 'arts'],
  '🎪': ['circus', 'tent', 'carnival', 'performance', 'show'],
  '🎬': ['movie', 'film', 'director', 'action', 'cinema', 'clapper'],
  '🎤': ['microphone', 'sing', 'music', 'voice', 'karaoke'],
  '🎧': ['headphones', 'music', 'listen', 'audio', 'sound'],
  '🎼': ['music', 'score', 'notes', 'sheet music', 'melody'],
  '🎹': ['piano', 'keyboard', 'music', 'instrument', 'keys'],
  '🖍️': ['crayon', 'draw', 'color', 'art', 'children', 'school'],
  '🖊️': ['pen', 'write', 'blue', 'ink', 'writing'],
  '📚': ['books', 'reading', 'library', 'study', 'education'],
  '🗂️': ['dividers', 'organize', 'files', 'folders', 'office'],
  '📋': ['clipboard', 'notes', 'write', 'list', 'document'],
  '🎆': ['fireworks', 'celebration', 'sparkle', 'festival', 'new year'],
  '🎇': ['sparkler', 'fireworks', 'light', 'celebration', 'sparkle'],
  '✨': ['sparkles', 'stars', 'shine', 'glitter', 'magic'],
  '💫': ['dizzy', 'star', 'spin', 'swirl', 'sparkle'],
  '🌈': ['rainbow', 'colors', 'sky', 'pride', 'nature'],
  '🎠': ['carousel', 'horse', 'carnival', 'ride', 'amusement'],
  '🎡': ['ferris wheel', 'carnival', 'ride', 'amusement park'],
  '🎢': ['roller coaster', 'ride', 'amusement park', 'thrill'],
  '🗿': ['moai', 'statue', 'easter island', 'stone', 'sculpture'],
  '🏰': ['castle', 'fairy tale', 'princess', 'medieval', 'fortress'],
  '💐': ['bouquet', 'flowers', 'gift', 'romance', 'celebration'],
  '🌺': ['hibiscus', 'flower', 'tropical', 'hawaii', 'nature'],
  '🌸': ['cherry blossom', 'flower', 'spring', 'pink', 'nature'],
  '🌼': ['blossom', 'flower', 'yellow', 'nature', 'spring'],
  
  // Emotions Category
  '❤️': ['heart', 'love', 'romance', 'valentine', 'affection', 'red', 'like', 'passion'],
  '🧡': ['heart', 'love', 'orange', 'affection', 'care', 'like', 'friendship'],
  '💛': ['heart', 'yellow', 'love', 'friendship', 'care', 'like', 'warmth'],
  '💚': ['heart', 'green', 'love', 'nature', 'eco', 'like', 'healing'],
  '💙': ['heart', 'blue', 'love', 'trust', 'loyalty', 'like', 'peace'],
  '💜': ['heart', 'purple', 'love', 'compassion', 'like', 'royal'],
  '🖤': ['heart', 'black', 'love', 'dark', 'edgy', 'like', 'gothic'],
  '🤍': ['heart', 'white', 'love', 'pure', 'clean', 'like', 'light'],
  '🤎': ['heart', 'brown', 'love', 'earth', 'natural', 'like'],
  '💔': ['broken heart', 'heartbreak', 'sad', 'pain', 'breakup'],
  '❣️': ['heart exclamation', 'love', 'emphasis', 'decoration'],
  '💕': ['two hearts', 'love', 'couple', 'romance', 'together'],
  '💞': ['revolving hearts', 'love', 'spin', 'dizzy', 'romance'],
  '💓': ['beating heart', 'love', 'pulse', 'alive', 'heartbeat'],
  '💗': ['growing heart', 'love', 'expand', 'excited', 'flutter'],
  '💖': ['sparkling heart', 'love', 'sparkle', 'glitter', 'excitement'],
  '💘': ['heart arrow', 'cupid', 'love', 'romance', 'valentine'],
  '💝': ['heart ribbon', 'gift', 'love', 'present', 'valentine'],
  '💟': ['heart decoration', 'love', 'purple', 'ornament'],
  '💌': ['love letter', 'mail', 'romance', 'message', 'valentine'],
  '💋': ['kiss mark', 'lips', 'love', 'romance', 'makeup'],
  '👥': ['silhouettes', 'people', 'shadows', 'group', 'users'],
  '👀': ['eyes', 'look', 'see', 'watch', 'peek', 'suspicious'],
  '🧠': ['brain', 'mind', 'think', 'smart', 'intelligence'],

  // People Category
  '👶': ['baby', 'child', 'infant', 'young', 'newborn', 'kid'],
  '👧': ['girl', 'child', 'young', 'kid', 'female'],
  '🧒': ['child', 'kid', 'young', 'gender neutral', 'youth'],
  '👦': ['boy', 'child', 'young', 'kid', 'male'],
  '👩': ['woman', 'female', 'lady', 'girl', 'adult'],
  '🧑': ['person', 'adult', 'gender neutral', 'human'],
  '👨': ['man', 'male', 'guy', 'adult', 'moustache'],
  '👱‍♀️': ['blonde woman', 'female', 'hair', 'yellow hair'],
  '👱': ['blonde person', 'hair', 'yellow hair'],
  '👴': ['old man', 'elder', 'senior', 'grandfather', 'aged'],
  '👵': ['old woman', 'elder', 'senior', 'grandmother', 'aged'],
  '👲': ['man with skullcap', 'asian', 'hat'],
  '👳‍♀️': ['woman with turban', 'headscarf', 'hijab'],
  '👳': ['person with turban', 'headwear', 'religious'],
  '👮‍♀️': ['police woman', 'cop', 'officer', 'law', 'security'],
  '👮': ['police officer', 'cop', 'law', 'security'],
  '💂‍♀️': ['guard woman', 'british', 'royal', 'security'],
  '💂': ['guard', 'british', 'royal', 'security', 'protect'],
  '👷‍♀️': ['construction worker woman', 'builder', 'hard hat'],
  '👷': ['construction worker', 'builder', 'hard hat', 'work'],
  '🤴': ['prince', 'royal', 'crown', 'king', 'male'],
  '👸': ['princess', 'royal', 'crown', 'queen', 'female'],
  '🧙‍♀️': ['woman mage', 'witch', 'wizard', 'magic', 'sorcerer'],
  '🧙': ['mage', 'wizard', 'magic', 'sorcerer', 'witch'],
  '🧚‍♀️': ['woman fairy', 'wings', 'magical', 'tinkerbell'],
  '🧚': ['fairy', 'wings', 'magical', 'fantasy', 'flying'],
  '🧛‍♀️': ['woman vampire', 'dracula', 'supernatural'],
  '🧛': ['vampire', 'dracula', 'supernatural', 'fantasy'],
  '🧜‍♀️': ['mermaid', 'sea', 'ocean', 'ariel', 'swim'],
  '🧜': ['merperson', 'sea', 'ocean', 'fantasy', 'swim'],
  '🧝‍♀️': ['woman elf', 'magical', 'fantasy', 'fairy tale'],
  '🧝': ['elf', 'magical', 'fantasy', 'lord of the rings'],
  '🧞‍♀️': ['woman genie', 'magical', 'wish', 'fantasy'],
  '🧞': ['genie', 'magical', 'wish', 'fantasy', 'lamp'],
  '💁': ['information desk person', 'help', 'sassy', 'service'],
  '🙅': ['no gesture', 'stop', 'deny', 'reject', 'refuse'],
  '🙆': ['ok gesture', 'agree', 'yes', 'approve'],
  '🙋': ['raising hand', 'volunteer', 'question', 'me'],
  '🧏': ['deaf person', 'hearing', 'accessibility'],
  '🙇': ['bow', 'sorry', 'apology', 'respect', 'regret'],
  '🤦': ['facepalm', 'disappointed', 'exasperated', 'duh'],
  '🤷': ['shrug', 'doubt', 'ignorance', 'who knows'],

  // Professional People
  '👨‍⚕️': ['doctor', 'health', 'medical', 'physician', 'hospital'],
  '👨‍🎓': ['student', 'graduate', 'education', 'university'],
  '👨‍🏫': ['teacher', 'instructor', 'professor', 'education'],
  '👨‍⚖️': ['judge', 'justice', 'court', 'law', 'legal'],
  '👨‍🌾': ['farmer', 'agriculture', 'gardener', 'plants'],
  '👨‍🍳': ['chef', 'cook', 'food', 'kitchen', 'restaurant'],
  '👨‍🔧': ['mechanic', 'technician', 'repair', 'tools'],
  '👨‍🏭': ['factory worker', 'industrial', 'manufacturing'],
  '👨‍💼': ['office worker', 'business', 'manager', 'professional'],
  '👨‍🔬': ['scientist', 'research', 'laboratory', 'chemistry'],
  '👨‍💻': ['technologist', 'programmer', 'computer', 'developer'],
  '👨‍🎤': ['singer', 'rock star', 'entertainer', 'performer'],
  '👨‍🎨': ['artist', 'painter', 'creative', 'designer'],
  '👨‍✈️': ['pilot', 'airplane', 'flight', 'aviation'],
  '👨‍🚀': ['astronaut', 'space', 'rocket', 'cosmos'],
  '👨‍🚒': ['firefighter', 'rescue', 'emergency', 'hero'],

  // Gestures Category
  '👋': ['wave', 'goodbye', 'hello', 'hi', 'greet'],
  '🤚': ['raised back of hand', 'stop', 'high five'],
  '🖐️': ['hand with fingers splayed', 'stop', 'high five'],
  '✋': ['raised hand', 'high five', 'stop', 'halt'],
  '🖖': ['vulcan salute', 'spock', 'star trek', 'prosper'],
  '👌': ['ok hand', 'perfect', 'good', 'approve'],
  '🤌': ['pinched fingers', 'italian', 'what', 'hand gesture'],
  '🤏': ['pinching hand', 'small', 'tiny', 'little bit'],
  '✌️': ['victory', 'peace', 'two', 'fingers'],
  '🤞': ['crossed fingers', 'luck', 'hopeful', 'wish'],
  '🤟': ['love you gesture', 'rock', 'hand sign'],
  '🤘': ['rock on', 'metal', 'horns', 'music'],
  '🤙': ['call me', 'phone', 'hang loose', 'shaka'],
  '👈': ['point left', 'direction', 'finger', 'hand'],
  '👉': ['point right', 'direction', 'finger', 'hand'],
  '👆': ['point up', 'direction', 'finger', 'hand'],
  '🖕': ['middle finger', 'rude', 'upset', 'offensive'],
  '👇': ['point down', 'direction', 'finger', 'hand'],
  '☝️': ['point up', 'direction', 'finger', 'hand'],
  '👍': ['thumbs up', 'approve', 'ok', 'good', 'like'],
  '👎': ['thumbs down', 'disapprove', 'no', 'bad', 'dislike'],
  '✊': ['raised fist', 'power', 'strength', 'solidarity'],
  '👊': ['punch', 'fist bump', 'hit', 'attack'],
  '🤛': ['left fist bump', 'punch', 'hand'],
  '🤜': ['right fist bump', 'punch', 'hand'],
  '👏': ['clap', 'applause', 'praise', 'approval'],
  '🙌': ['raised hands', 'celebration', 'praise', 'hooray'],
  '👐': ['open hands', 'hug', 'welcome', 'spread'],
  '🤲': ['palms up together', 'pray', 'beg', 'please'],
  '🤝': ['handshake', 'agreement', 'deal', 'greeting'],
  '🙏': ['pray', 'please', 'hope', 'wish', 'thank you'],
  '✍️': ['writing hand', 'write', 'note', 'signature'],
  '💅': ['nail polish', 'manicure', 'beauty', 'fashion'],
  '🤳': ['selfie', 'photo', 'camera', 'phone'],
  '💪': ['flexed biceps', 'strong', 'muscle', 'strength'],
};

export const searchEmojisByKeyword = (searchTerm, emojiCategories) => {
  if (!searchTerm) return emojiCategories;
  
  const searchTermLower = searchTerm.toLowerCase();
  const filtered = {};
  
  Object.entries(emojiCategories).forEach(([category, emojis]) => {
    const filteredEmojis = emojis.filter(emoji => {
      // Direct emoji match
      if (emoji.includes(searchTermLower)) return true;
      
      // Keyword match
      const keywords = emojiMetadata[emoji] || [];
      return keywords.some(keyword => 
        keyword.toLowerCase().includes(searchTermLower)
      );
      
      // Category match
      if (category.toLowerCase().includes(searchTermLower)) return true;
    });
    
    if (filteredEmojis.length > 0) {
      filtered[category] = filteredEmojis;
    }
  });
  
  return filtered;
};